import {useContext} from 'react'

import Context from '@s-ui/react-context'
import IconCheck from '@adv-mt/mt-svg-icons/lib/CircleCheckOutline.js'
import LockOutline from '@adv-mt/mt-svg-icons/lib/LockOutline'

import {RESERVATION_STATUSES} from '../../utils/config.js'

export const useCardDataInfo = currentStatus => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')

  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const logoThirdParty = `${URL_STATICS_IMAGES}coches/transaction/credit-cards.svg`
  const logoGooglePay = `${URL_STATICS_IMAGES}coches/transaction/google-pay.svg`

  const hasReservableStatus = currentStatus === RESERVATION_STATUSES.RESERVABLE

  const cardData = {
    [RESERVATION_STATUSES.OTHER_RESERVATION]: {
      hasActionButton: false,
      notificationInfo: {
        Icon: LockOutline,
        text: i18n.t('VEHICLE_RESERVATION.NOTIFICATION.OTHER_RESERVATION.TEXT'),
        type: 'info'
      },
      text: '',
      title: i18n.t('VEHICLE_RESERVATION.NOTIFICATION.OTHER_RESERVATION.TITLE')
    },
    [RESERVATION_STATUSES.OWN_RESERVATION]: {
      hasActionButton: true,
      notificationInfo: {
        Icon: IconCheck,
        text: i18n.t('VEHICLE_RESERVATION.NOTIFICATION.OWN_RESERVATION.TEXT'),
        type: 'success'
      },
      text: i18n.t('VEHICLE_RESERVATION.NOTIFICATION.OWN_RESERVATION.DESCRIPTION'),
      title: i18n.t('VEHICLE_RESERVATION.NOTIFICATION.OWN_RESERVATION.TITLE')
    },
    [RESERVATION_STATUSES.RESERVABLE]: {}
  }

  const thirdPartyInfo = {
    title: i18n.t('VEHICLE_RESERVATION.PANEL_SERVICE.TITLE'),
    text: i18n.t('VEHICLE_RESERVATION.PANEL_SERVICE.SUBTITLE'),
    buttonText: i18n.t('VEHICLE_RESERVATION.PANEL_SERVICE.CTA'),
    bottomText: i18n.t('COMMON.PAY_WITH'),
    bottomTextImg: logoThirdParty,
    bottomTextImgGooglePay: logoGooglePay
  }

  if (hasReservableStatus) return thirdPartyInfo
  return cardData[currentStatus]
}
